// src/pages/CertificadoDigital.js
import React from 'react';
import { Helmet } from 'react-helmet';
import './CertificadoDigital.css';

// Importando as imagens (removida a 'cloudImage')
import logoCertisign from '../assets/logoCertisign.png';
import logoPts from '../assets/logo.png';
import heroImage from '../assets/certificado-digital-ecpf.jpg'; // Homem sorrindo sentado
import partnerImage from '../assets/certificado-digital-ecnpj.jpg'; // Mulher em pé com tablet
import validationImage from '../assets/validacao-por-videoconferencia.jpg'; // Homem em pé com tablet

const CertificadoDigital = () => {
    // URL final e correta para todos os CTAs de venda
    const certisignPartnerUrl = "https://certisign.com.br/parceiros/first";

    return (
        <div className="cert-digital-page"> {/* ESTA CLASSE É A "JAULA" */}
            <Helmet>
                <title>Comprar Certificado Digital e-CPF/e-CNPJ A1 e A3 | Validação Online</title>
                <meta name="description" content="Compre ou renove seu Certificado Digital Certisign (e-CPF, e-CNPJ, A1, A3) com o suporte da PTS. Processo 100% online com validação por videoconferência. Clique e emita já!" />
                <script type="application/ld+json">
                {`
                    {
                      "@context": "https://schema.org",
                      "@type": "Service",
                      "serviceType": "Emissão de Certificado Digital",
                      "provider": { "@type": "Organization", "name": "PTS - Primo Trade Solutions", "url": "https://pts.dev.br" },
                      "broker": { "@type": "Brand", "name": "Certisign" },
                      "areaServed": {
                        "@type": "Country",
                        "name": "BR"
                      },
                      "description": "Serviço de emissão e renovação online de certificados digitais e-CPF e e-CNPJ, modelos A1 e A3, com validação por videoconferência. Parceria oficial Certisign.",
                      "offers": {
                        "@type": "Offer",
                        "url": "${certisignPartnerUrl}",
                        "priceCurrency": "BRL"
                      }
                    }
                `}
                </script>
            </Helmet>

            {/* --- Bloco 1: Herói --- */}
            <section className="hero-cert" style={{ backgroundImage: `url(${heroImage})` }}>
                <div className="hero-overlay"></div>
                <div className="container hero-content">
                    <h1>Certificado Digital Online, Rápido e Seguro</h1>
                    <p>Emita ou renove seu e-CPF ou e-CNPJ com a líder Certisign e o suporte especialista da PTS. Validação por videoconferência, sem sair de casa.</p>
                    <a href={certisignPartnerUrl} target="_blank" rel="noopener noreferrer" className="cta-button">
                        Ver Preços e Comprar Agora
                    </a>
                </div>
            </section>
            
            {/* --- Bloco 2: Barra de Confiança --- */}
            <section className="confianca-bar">
                <div className="container confianca-container">
                    <span>Parceiro Oficial da Maior Autoridade Certificadora do Brasil</span>
                    <div className="logos">
                        <img src={logoPts} alt="Logo da Primo Trade Solutions" />
                        <span>+</span>
                        <img src={logoCertisign} alt="Logo da Certisign" />
                    </div>
                </div>
            </section>

            {/* --- Bloco 3: Qual sua necessidade? --- */}
            <section className="tipos-cert">
                <div className="container">
                    <h2>Qual certificado você precisa?</h2>
                    <p className="section-subtitle">Encontre a solução ideal para sua necessidade específica.</p>
                    <div className="cards-container">
                        <div className="card">
                            <div className="card-icon">👤</div>
                            <h3>e-CPF</h3>
                            <p>Sua assinatura digital como pessoa física. Ideal para profissionais liberais, acesso ao e-CAC, Gov.br e assinatura de documentos com validade jurídica.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">🏢</div>
                            <h3>e-CNPJ</h3>
                            <p>A identidade digital da sua empresa. Indispensável para emitir NF-e, cumprir obrigações fiscais e operar sistemas do governo com segurança.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">📄</div>
                            <h3>NF-e</h3>
                            <p>Exclusivo para a emissão de Notas Fiscais Eletrônicas. Permite delegar a função de faturamento sem expor o e-CNPJ principal da empresa.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* --- Bloco 4: Comparativo A1 vs A3 --- */}
            <section className="comparativo-cert">
                <div className="container comparativo-container">
                    <div className="comparativo-column">
                        <h2>Modelo A1: Agilidade</h2>
                        <p>O certificado A1 é um **arquivo digital** (.pfx) instalado diretamente no seu computador ou servidor. É a escolha ideal para quem busca agilidade e automação, principalmente para emissão de notas fiscais em alto volume.</p>
                        <ul>
                            <li>✓ Instalado no Computador</li>
                            <li>✓ Ideal para Automação de NF-e</li>
                            <li>✓ Permite Backup e uso em rede</li>
                            <li><strong>Validade:</strong> 1 ano</li>
                        </ul>
                    </div>
                    <div className="comparativo-column comparativo-column-destaque">
                        <h2>Modelo A3: Segurança</h2>
                        <p>O certificado A3 é armazenado em uma **mídia externa** (Token USB, Cartão) ou na **Nuvem**. Oferece segurança máxima, pois a chave privada nunca deixa o dispositivo. Perfeito para quem precisa de portabilidade e validade estendida.</p>
                        <ul>
                            <li>✓ Armazenado em Mídia ou Nuvem</li>
                            <li>✓ Segurança Máxima e Portabilidade</li>
                            <li>✓ Uso manual com senha a cada assinatura</li>
                            <li><strong>Validade:</strong> Até 5 anos</li>
                        </ul>
                    </div>
                </div>
                <a href={certisignPartnerUrl} target="_blank" rel="noopener noreferrer" className="cta-button">
                    Escolher Modelo e Ver Preços
                </a>
            </section>

            {/* --- Bloco 5: Como Funciona (Processo Simplificado) --- */}
            <section className="como-funciona-cert">
                 <div className="container">
                    <h2>Compre seu certificado em 3 passos simples</h2>
                    <p className="section-subtitle">Nosso processo é 100% online, do pagamento à validação.</p>
                    <div className="processo-container">
                        <div className="processo-step">
                            <div className="step-number">1</div>
                            <h3>Compre Online</h3>
                            <p>Acesse nosso portal seguro, escolha seu certificado e pague com segurança.</p>
                        </div>
                        <div className="processo-step">
                            <div className="step-number">2</div>
                            <h3>Valide por Vídeo</h3>
                            <p>Agende e realize a validação de identidade por videoconferência no seu melhor horário.</p>
                        </div>
                        <div className="processo-step">
                            <div className="step-number">3</div>
                            <h3>Instale e Use</h3>
                            <p>Receba por e-mail as instruções para emitir e instalar seu certificado. Pronto para usar!</p>
                        </div>
                    </div>
                    <div className="validation-section">
                        <img src={validationImage} alt="Homem realiza validação de identidade por videoconferência para emitir seu certificado digital." className="validation-image"/>
                        <div className="validation-text">
                            <h3>Validação por Videoconferência</h3>
                            <p>Realize a etapa mais importante de onde estiver. O processo de validação por vídeo é rápido, seguro e credenciado pela ICP-Brasil, garantindo a mesma validade jurídica do presencial, com muito mais conveniência.</p>
                        </div>
                    </div>
                </div>
            </section>
            
             {/* --- Bloco 6: Parceria de Confiança --- */}
            <section className="parceria-cert">
                <div className="container parceria-container">
                    <div className="parceria-image">
                        <img src={partnerImage} alt="Consultora da PTS pronta para auxiliar clientes com seus certificados digitais Certisign." />
                    </div>
                    <div className="parceria-text">
                        <h2>A Segurança da Líder com o Suporte que Você Confia</h2>
                        <p>Somos uma Autoridade de Registro (AR) oficial da Certisign. Isso significa que, ao comprar conosco, você une a tecnologia e a confiabilidade da maior certificadora do país com o suporte próximo e especialista da PTS para garantir que sua experiência seja a melhor possível.</p>
                        <a href={certisignPartnerUrl} target="_blank" rel="noopener noreferrer" className="cta-button cta-button-dark">
                            Comprar com Segurança na Certisign
                        </a>
                    </div>
                </div>
            </section>

            {/* --- Bloco 7: FAQ --- */}
            <section className="faq-cert">
                <div className="container">
                    <h2>Perguntas Frequentes</h2>
                    <div className="faq-container">
                        <details className="faq-item">
                            <summary>O certificado emitido por videoconferência tem a mesma validade?</summary>
                            <p>Sim, total. A validação por videoconferência é um método homologado pela ICP-Brasil e confere exatamente a mesma validade jurídica, segurança e aceitação de um certificado emitido presencialmente.</p>
                        </details>
                        <details className="faq-item">
                            <summary>Como funciona a renovação do certificado digital?</summary>
                            <p>A renovação estende a validade do seu certificado. Se ele ainda estiver válido, o processo é mais simples e também pode ser feito online. Recomendamos iniciar a renovação 30 dias antes do vencimento para evitar qualquer interrupção em suas operações.</p>
                        </details>
                        <details className="faq-item">
                            <summary>Posso instalar o certificado A1 em mais de um computador?</summary>
                            <p>Sim. O A1 é um arquivo e pode ser instalado em quantos computadores forem necessários (seu, do contador, etc.). É crucial que você faça um backup seguro (cópia de segurança) do arquivo e da senha.</p>
                        </details>
                        <details className="faq-item">
                            <summary>Preciso de um leitor de cartão para o certificado A3?</summary>
                            <p>Se você optar pelo A3 em **cartão**, sim, precisará de uma leitora compatível. Se optar pelo A3 em **token** (parecido com um pendrive) ou **Nuvem**, não precisará de leitora.</p>
                        </details>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CertificadoDigital;